import React, { useEffect, useRef, useState } from "react";
import CustomDropdown from "../../../../../components/Dropdown";
import { FaPlus } from "react-icons/fa";
import CreateTransactionModal from "./createTransaction";
import { Toast } from "primereact/toast";
import ReturnComponent from "./stockComponent/returnComponent";
import TradeComponent from "./stockComponent/tradeComponent";
import RiskComponent from "./stockComponent/riskCompoenent";
import MovementComponent from "./stockComponent/movementComponent";
import {
  formatNumber,
  getBreadcrumbLabelsByAssetType,
  getDropdownLabelsByAssetType,
  getTabLabelsByAssetType,
  HorizontalTabButtons,
  truncateText,
  truncateToTwoDecimals,
  TwoDecimalsWithoutRounding,
} from "../../../../../utility/helper";
import {
  deleteTransaction,
  getCompanyprofileService,
  getFutureTransaction,
  getRoiService,
  getStockTransaction,
} from "../../../../../services/transaction";
import ConfirmDialog from "../../../../../components/ConfirmDialog";
import {
  clearSelectedAsset,
  fetchUserAssets,
  setSelectedAsset,
} from "../../../../../redux/slices/userAssetsSlice";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { handleErrorRedirect } from "../../../../../utility/errorRedirect";
import Breadcrumb from "../../../../../components/Breadcrumb";
import AssetGuardedActionButton from "../../../../../components/AddTransactionButton";
import StockSkeleton from "./stockComponent/stockSkelton";

const ViewTransaction = () => {
  const [modalVisible, setModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [companyLoading, setCompanyLoading] = useState(false);
  const [graphLoading, setGraphLoading] = useState(false);

  const dropdownOptions = getDropdownLabelsByAssetType("2");
  const breadcrumbItems = getBreadcrumbLabelsByAssetType("Stock");
  const { currency } = useSelector((state) => state.user);

  const [type, setType] = useState("");
  const [singleTransactionData, setSingleTransactionData] = useState({});
  const [limit, setLimit] = useState(20);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(0);
  const [viewTransaction, setViewTransaction] = useState([]);
  const [viewFutureTransaction, setViewFutureTransaction] = useState([]);
  const [graphROI, setGraphROI] = useState([]);
  const [companyDetails, setCompanyDetails] = useState({});
  const [actionTypes, setActionTypes] = useState("Create");
  const [selectedButton, setSelectedButton] = useState("Return");
  const accessToken = JSON.parse(localStorage.getItem("access_token"));
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [dialogConfig, setDialogConfig] = useState({});
  const toast = useRef(null);
  const dispatch = useDispatch();
  const userAssets = useSelector((state) => state.userAssets.data);
  const { selectedAsset, userAssetLoading } = useSelector(
    (state) => state.userAssets
  );
  const location = useLocation();
  const id = location?.state?.id || null;
  const navigate = useNavigate();
  const tabOptions = getTabLabelsByAssetType("2");

  useEffect(() => {
    if (selectedAsset && selectedAsset?.id && selectedAsset?.symbol) {
      GetTransactionData();
      GetFutureTransactionData();
      GetRoiData();
      GetCompanyprofile();
    }
  }, [selectedAsset?.id, page]);

  const isNegativeROI = (graphROI?.avg_roi ?? 0) < 0;

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    dispatch(fetchUserAssets({ assetTypeId: 2, selectedAssetId: id })).then(
      (resultAction) => {
        if (fetchUserAssets.rejected.match(resultAction)) {
          const status = resultAction?.payload?.status;
          handleErrorRedirect(status, navigate);
        }
      }
    );
    return () => {
      dispatch(clearSelectedAsset());
    };
  }, [dispatch, id]);

  const openConfirmDialog = (config) => {
    setDialogConfig(config);
    setIsDialogOpen(true);
  };

  const handleOptionSelect = (option, actionTypes, data) => {
    setModalVisible(true);
    setType(option);
    setActionTypes(actionTypes);
    setSingleTransactionData(data);
  };

  const GetRoiData = async () => {
    setGraphLoading(true);
    try {
      const response = await getRoiService(selectedAsset?.id, accessToken);
      if (response.status === 200) {
        const data = response?.data.data;
        setGraphROI(data);
      } else {
        throw new Error("Failed to fetch user data");
      }
    } catch (err) {
      const status = err?.response?.status;
      handleErrorRedirect(status, navigate);
    } finally {
      setGraphLoading(false);
    }
  };

  const GetCompanyprofile = async () => {
    setCompanyLoading(true);
    try {
      const response = await getCompanyprofileService(
        selectedAsset?.symbol,
        accessToken
      );
      if (response.status === 200) {
        const data = response?.data.data;
        setCompanyDetails(data);
      } else {
        throw new Error("Failed to fetch user data");
      }
    } catch (err) {
      console.error("Error fetching company profile:", err);
      setCompanyDetails({});
      const status = err?.response?.status;
      handleErrorRedirect(status, navigate);
    } finally {
      setCompanyLoading(false);
    }
  };

  const GetTransactionData = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await getStockTransaction(
        selectedAsset?.id,
        page * limit,
        limit,
        "All",
        accessToken
      );
      if (response.status === 200) {
        setViewTransaction(response?.data.data);
      } else {
        throw new Error("Failed to fetch user data");
      }
    } catch (err) {
      setError(err.message || "An error occurred");
      const status = err?.response?.status;
      handleErrorRedirect(status, navigate);
    } finally {
      setLoading(false);
    }
  };

  const GetFutureTransactionData = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await getFutureTransaction(
        selectedAsset?.id,
        page,
        limit,
        "All",
        2,
        accessToken
      );
      if (response.status === 200) {
        setViewFutureTransaction(response?.data.data);
      } else {
        throw new Error("Failed to fetch user data");
      }
    } catch (err) {
      setError(err.message || "An error occurred");
      const status = err?.response?.status;
      handleErrorRedirect(status, navigate);
    } finally {
      setLoading(false);
    }
  };

  const handleTransactionDelete = async (user) => {
    try {
      const accessToken = JSON.parse(localStorage.getItem("access_token"));
      const response = await deleteTransaction(accessToken, user?.id);
      if (response) {
        dispatch(fetchUserAssets({ assetTypeId: 2, selectedAssetId: id }));
        GetRoiData();
        GetTransactionData();
        GetFutureTransactionData();
        toast.current.show({
          className: "bg-green-300 text-white",
          severity: "success",
          summary: "Success",
          detail: "transaction deleted successfully",
          life: 3000,
        });
      }
    } catch (err) {
      const status = err?.response?.status;
      handleErrorRedirect(status, navigate);
      toast.current.show({
        className: "bg-yellow-700 text-white",
        severity: "warn",
        summary: "Warning",
        detail: err.message,
        life: 3000,
      });
    }
  };

  const confirmTransactionDelete = (transactionId) => {
    openConfirmDialog({
      title: "Confirm Delete",
      message: "Are you sure you want to delete this transaction?",
      confirmText: "Delete",
      cancelText: "Cancel",
      cancelClass:
        "ml-6 inline-flex justify-center px-4 py-2 items-center gap-1 text-sm font-medium border dark:border-gray-300 border-info rounded-md bg-transparent text-info dark:text-grey rounded-md focus:outline-none",
      confirmClass:
        "ml-6 inline-flex justify-center px-4 py-2 items-center gap-1 text-sm font-medium dark:text-black dark:button-primary-gradient rounded-md bg-lightPrimary text-white rounded-md focus:outline-none",
      onConfirm: () => handleTransactionDelete(transactionId),
    });
  };

  return (
    <>
      <Toast ref={toast} />
      <ConfirmDialog
        isOpen={isDialogOpen}
        setIsOpen={setIsDialogOpen}
        {...dialogConfig}
      />
      <div>
        {/* <Breadcrumb items={breadcrumbItems} className="md:ml-5 mb-2" /> */}
        <div className="font-bold flex items-center flex-row justify-between px-4">
          <HorizontalTabButtons
            buttons={tabOptions}
            selected={selectedButton}
            onSelect={setSelectedButton}
          />
          <AssetGuardedActionButton
            userAssets={userAssets}
            onOptionSelect={handleOptionSelect}
            dropdownOptions={dropdownOptions}
            truncateText={truncateText}
            setIsDialogOpen={setIsDialogOpen}
            openConfirmDialog={openConfirmDialog}
            navigate={navigate}
            navigatePath="/my-view"
            assetsName={"Stock"}
          />
        </div>

        <div className="border border-lightPrimary/40 dark:border-info/40 p-3 mx-4 my-3 dark:bg-card-custom-radials bg-[length:100%_200%] bg-white">
          <div className="text-gray-400">
            <CustomDropdown
              options={userAssets}
              name={selectedAsset ? selectedAsset?.name : "Select Asset"}
              assetId={selectedAsset ? selectedAsset?.id : "Select Asset"}
              onOptionSelect={(option) => dispatch(setSelectedAsset(option))}
              returnFullObject={true}
              truncateText={truncateText}
              size={19}
              disabled={!selectedAsset || !selectedAsset.name}
              className="inline-flex whitespace-nowrap disabled:cursor-not-allowed disabled:dark:opacity-75 disabled:border-none justify-center px-1 py-1.5  items-center gap-1 text-[0.65rem] font-medium bg-transparent rounded-md text-lightPrimary dark:text-white border border-transparent hover:border-dark"
            />
          </div>
          {userAssetLoading || graphLoading ? (
            <StockSkeleton />
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {/* <div
              className={`ml-1 text-2xl ${
                isNegativeROI
                  ? "text-warning"
                  : "text-lightPrimary dark:text-primary-gradient"
              }`}
            >
              {selectedAsset?.name}
            </div> */}
              <div className="space-y-3 text-info dark:text-grey text-sm ml-1 w-full max-w-[25rem]">
                <div className="flex items-baseline gap-24">
                  <span className="whitespace-nowrap">Value:</span>
                  <span
                    className={`text-2xl break-anywhere ${
                      isNegativeROI || Number(graphROI?.current_value ?? 0) < 0
                        ? "dark:text-warning text-expense"
                        : "text-lightPrimary dark:text-primary-gradient"
                    } font-medium break-all`}
                  >
                    {formatNumber(
                      truncateToTwoDecimals(
                        Number(
                          graphROI?.current_value ? graphROI.current_value : 0
                        )
                      )
                    )}{" "}
                    {currency ? currency : ""}
                  </span>
                </div>
                <div className="space-y-3 text-sm">
                  <div className="flex items-baseline gap-12">
                    <span className="whitespace-nowrap">Market Price:</span>
                    <span
                      className={`text-2xl break-anywhere text-lightPrimary dark:text-primary-gradient font-medium break-all`}
                    >
                      {formatNumber(
                        truncateToTwoDecimals(
                          Number(
                            graphROI?.current_price ? graphROI.current_price : 0
                          )
                        )
                      )}{" "}
                      {currency ? currency : ""}
                    </span>
                  </div>
                  <div className="flex items-baseline gap-5">
                    <span className="whitespace-nowrap">
                      Acquisition Price:
                    </span>
                    <span
                      className={`text-2xl break-anywhere text-lightPrimary dark:text-primary-gradient font-medium break-all`}
                    >
                      {formatNumber(
                        truncateToTwoDecimals(
                          Number(
                            graphROI?.average_buying_price
                              ? graphROI.average_buying_price
                              : 0
                          )
                        )
                      )}{" "}
                      {currency ? currency : ""}
                    </span>
                  </div>
                  <div className="flex items-baseline gap-[4.7rem]">
                    <span className="whitespace-nowrap">Quantity:</span>
                    <span
                      className={`text-2xl break-anywhere text-lightPrimary dark:text-primary-gradient font-medium break-all`}
                    >
                      {formatNumber(
                        truncateToTwoDecimals(
                          Number(
                            graphROI?.total_quantity
                              ? graphROI.total_quantity
                              : 0
                          )
                        )
                      )}
                    </span>
                  </div>
                </div>
              </div>

              <div className="space-y-2 text-sm text-info dark:text-grey w-full max-w-[25rem]">
                <div className="flex items-baseline gap-4">
                  <span className="whitespace-nowrap">Gain/Loss:</span>
                  <span
                    className={`text-2xl break-anywhere ${
                      isNegativeROI || Number(graphROI?.total_gain ?? 0) < 0
                        ? "dark:text-warning text-expense"
                        : "text-lightPrimary dark:text-primary-gradient"
                    } font-medium break-all`}
                  >
                    {formatNumber(
                      truncateToTwoDecimals(
                        Math.abs(
                          (Number(graphROI?.avg_realized || 0) || 0) +
                            (Number(graphROI?.avg_unrealized || 0) || 0) +
                            (Number(viewTransaction?.total_income || 0) || 0) -
                            (Number(viewTransaction?.total_expense || 0) || 0)
                        )
                      ) || 0
                    )}{" "}
                    {currency ? currency : ""}
                  </span>
                </div>
                <div className="flex items-baseline gap-x-14 gap-y-4">
                  <span className="mr-1 whitespace-nowrap">ROI:</span>
                  <span
                    className={`text-2xl break-anywhere ${
                      isNegativeROI || Number(graphROI?.avg_roi ?? 0) < 0
                        ? "dark:text-warning text-expense"
                        : "text-lightPrimary dark:text-primary-gradient"
                    } font-medium break-all`}
                  >
                    {formatNumber(
                      Math.abs(
                        graphROI?.avg_roi
                          ? TwoDecimalsWithoutRounding(graphROI.avg_roi * 100)
                          : 0
                      )
                    )}
                    %
                  </span>
                </div>
              </div>

              <div className="grid grid-col-2 text-sm text-info dark:text-grey w-full max-w-[25rem]">
                <div className="space-y-3">
                  <div className="flex items-baseline gap-8">
                    <span className="whitespace-nowrap">
                      {Number(graphROI?.avg_realized ?? 0) < 0
                        ? "Realised Loss:"
                        : "Realised Profit:"}
                    </span>
                    <span
                      className={`text-2xl text-wrap break-anywhere ${
                        isNegativeROI || Number(graphROI?.avg_realized ?? 0) < 0
                          ? "dark:text-warning text-expense"
                          : "text-lightPrimary dark:text-primary-gradient"
                      } font-medium break-all`}
                    >
                      {formatNumber(
                        truncateToTwoDecimals(
                          Math.abs(
                            Number(
                              graphROI?.avg_realized ? graphROI.avg_realized : 0
                            )
                          )
                        )
                      )}{" "}
                      {currency ? currency : ""}
                    </span>
                  </div>
                  <div className="flex items-baseline gap-5">
                    <span className="whitespace-nowrap">
                      {Number(graphROI?.avg_unrealized ?? 0) < 0
                        ? "Unrealised Loss:"
                        : "Unrealised Profit:"}
                    </span>
                    <span
                      className={`text-2xl text-wrap break-anywhere ${
                        isNegativeROI ||
                        Number(graphROI?.avg_unrealized ?? 0) < 0
                          ? "dark:text-warning text-expense"
                          : "text-lightPrimary dark:text-primary-gradient"
                      } font-medium break-all`}
                    >
                      {formatNumber(
                        truncateToTwoDecimals(
                          Math.abs(
                            Number(
                              graphROI?.avg_unrealized
                                ? graphROI.avg_unrealized
                                : 0
                            )
                          )
                        )
                      )}{" "}
                      {currency ? currency : ""}
                    </span>
                  </div>
                </div>
              </div>
              <div className="grid grid-col-2 text-sm text-info dark:text-grey w-full max-w-[25rem]">
                <div className="space-y-3">
                  <div className="flex items-baseline gap-7">
                    <span className="whitespace-nowrap">Income:</span>
                    <span
                      className={`text-2xl text-wrap break-anywhere ${
                        isNegativeROI
                          ? "text-lightPrimary dark:text-primary-gradient"
                          : "text-lightPrimary dark:text-primary-gradient"
                      } font-medium break-all`}
                    >
                      {formatNumber(
                        truncateToTwoDecimals(
                          Math.abs(
                            Number(
                              viewTransaction?.total_income
                                ? viewTransaction?.total_income
                                : 0
                            )
                          )
                        )
                      )}{" "}
                      {currency ? currency : ""}
                    </span>
                  </div>
                  <div className="flex items-baseline gap-[1.4rem]">
                    <span className="whitespace-nowrap">Expense:</span>
                    <span className="text-warning text-wrap text-2xl break-all font-medium break-anywhere">
                      {formatNumber(
                        viewTransaction?.total_expense
                          ? viewTransaction?.total_expense
                          : 0
                      )}{" "}
                      {currency ? currency : ""}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="mt-5 mx-4">
          {selectedButton === "Return" && (
            <ReturnComponent
              graphROI={graphROI}
              companyDetails={companyDetails}
              selectedAsset={selectedAsset}
              isNegativeROI={isNegativeROI}
              userAssetLoading={userAssetLoading}
              companyLoading={companyLoading}
              graphLoading={graphLoading}
            />
          )}
          {selectedButton === "Trade" && <TradeComponent />}
          {selectedButton === "Risk" && <RiskComponent />}
          {selectedButton === "Movements" && (
            <MovementComponent
              confirmDelete={confirmTransactionDelete}
              handleOptionSelect={handleOptionSelect}
              viewTransaction={viewTransaction}
              viewFutureTransaction={viewFutureTransaction}
              setLimit={setLimit}
              limit={limit}
              setPage={setPage}
              page={page}
              selectedAsset={selectedAsset}
              isNegativeROI={isNegativeROI}
            />
          )}
        </div>
      </div>
      <CreateTransactionModal
        visible={modalVisible}
        singleTransactionData={singleTransactionData}
        actionTypes={actionTypes}
        fetchTransactionData={GetTransactionData}
        fetchFutureTransactionData={GetFutureTransactionData}
        GetRoiData={GetRoiData}
        viewTransaction={viewTransaction}
        onHide={() => {
          setModalVisible(false);
        }}
        SelectType={type}
        toast={toast}
        loading={loading}
        setLoading={setLoading}
        assetName={selectedAsset}
      />
    </>
  );
};

export default ViewTransaction;
